import { NotificationBar } from '../../../components';
import { ToastAsync, ToastStatus } from '../toast.type';
import style from './toast-notification.module.scss';
import { getToastErrorDetails } from './toast-notification.function';
import { ReactNode } from 'react';

type PromiseToastNotificationProps = {
  toast: ToastAsync;
  status: ToastStatus;
  icon?: ReactNode;
  closeToast: () => void;
};

const mapToastStatus = (toastStatus: ToastStatus) => {
  switch (toastStatus) {
    case 'error':
      return NotificationBar.STATUS.ERROR;
    case 'info':
      return NotificationBar.STATUS.INFO;
    case 'success':
      return NotificationBar.STATUS.SUCCESS;
    case 'alert':
      return NotificationBar.STATUS.ALERT;
    default:
      return NotificationBar.STATUS.DEFAULT;
  }
};

const getToastMessage = (status: ToastStatus, toast: ToastAsync) => {
  switch (status) {
    case 'info':
      return toast.message;
    case 'success':
      return toast.successMessage;
    case 'error':
      return toast.errorMessage;
    default:
      return toast.message;
  }
};

const getToastTitle = (status: ToastStatus, toast: ToastAsync) => {
  switch (status) {
    case 'info':
      return toast.title;
    case 'success':
      return toast.promiseCompleteTitle;
    case 'error':
      return toast.promiseCompleteErrorTitle ?? toast.promiseCompleteTitle;
    default:
      return toast.title;
  }
};

export const PromiseToastNotification = ({
  toast,
  status,
  icon,
  closeToast
}: PromiseToastNotificationProps) => {
  const { isSupportError, errorMessage, supportIdText } = getToastErrorDetails(
    status,
    toast.message
  );

  return (
    <NotificationBar
      className={style.toastMessage}
      title={getToastTitle(status, toast)}
      status={mapToastStatus(status)}
      roundedTop
      roundedBottom
      icon={icon}
      variant={NotificationBar.VARIANT.TERTIARY}
      showDismiss={status !== 'info'}
      highlight={false}
      onDismiss={() => closeToast()}
      buttonPosition={NotificationBar.BUTTON_POSITION.BOTTOM}
      subtitle={
        <>
          {isSupportError ? (
            <>
              <p>{errorMessage}</p>
              <span className={style.greyed}>{supportIdText}</span>
            </>
          ) : (
            getToastMessage(status, toast)
          )}
        </>
      }
    />
  );
};
